import {RootState} from '../reducer/index'
import {_CALL_API} from '../../middleware/api'
import {route} from '../../../conf/routes'
import {_API} from './_Action'
import { CotationCriteria } from 'src/type/criteria/cotationCriteria'
import { SignatureCriteria } from 'src/type/criteria/signatureCriteria'
import { TransactionCriteria } from 'src/type/criteria/transactionCriteria'

export const fetchDashboardCotations = () => (dispatch, getState: () => RootState) => {
  const actions = _API('PAGINATE_dashboardCotations')
  const criteria = {
    order_by: "desc",
    sort_by: "created_at",
    status: "LIVE,EXPIRED,DONE",
    limit: 3
  }
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.cotations.fetch(enterpriseId, criteria as CotationCriteria)
    }
  })
}

export const fetchTransactionChange = () => (dispatch, getState: () => RootState) => {
  const actions = _API('PAGINATE_dashboardTransactionsChange')
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  const criteria = {
    order_by: "desc",
    sort_by: "created_at",
    limit: 3
  }
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.transactions.fetchChange(enterpriseId, criteria as TransactionCriteria)
    }
  })
}

export const fetchTransactionDette = () => (dispatch, getState: () => RootState) => {
  const actions = _API('PAGINATE_dashboardTransactionsDette')
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  const criteria = {
    order_by: "desc",
    sort_by: "created_at",
    limit: 3
  }
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.transactions.fetchDette(enterpriseId, criteria as TransactionCriteria)
    }
  })
}


export const fetchTransactionPlacement = () => (dispatch, getState: () => RootState) => {
  const actions = _API('PAGINATE_dashboardTransactionsPlacement')
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  const criteria = {
    order_by: "desc",
    sort_by: "created_at",
    limit: 3
  }
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.transactions.fetchPlacement(enterpriseId, criteria as TransactionCriteria)
    }
  })
}



export const fetchDocToSign = () => (dispatch, getState: () => RootState) => {
  const actions = _API('PAGINATE_dashboardDocToSign')
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  const criteria = {
    order_by: "desc",
    sort_by: "sent_at",
    limit: 3
  }
  return dispatch({
    [_CALL_API]: {
      types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
      route: route.signature.searchDocToSign(enterpriseId, criteria as SignatureCriteria)
    }
  })
}

export const fetchDocSigned = () => (dispatch, getState: () => RootState) => {
    const actions = _API('PAGINATE_dashboardSignatures')
    const enterpriseId = getState().accountInfo.enterpriseSelected.id
    const criteria = {
      order_by: "desc",
      sort_by: "created_at",
      limit: 3
    }
    return dispatch({
      [_CALL_API]: {
        types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
        route: route.signature.searchDocSigned(enterpriseId, criteria as SignatureCriteria)
      }
    })
}

export const fetchOtherDoc = () => (dispatch, getState: () => RootState) => {
    const actions = _API('PAGINATE_dashboardDocNotToSign')
    const enterpriseId = getState().accountInfo.enterpriseSelected.id
    const criteria = {
      order_by: "desc",
      sort_by: "sent_at",
      limit: 3
    }
    return dispatch({
      [_CALL_API]: {
        types: [actions.REQUEST, actions.SUCCESS, actions.FAILURE],
        route: route.signature.searchDocNotToSign(enterpriseId, criteria as SignatureCriteria)
      }
    })
}


// WEBPACK FOOTER //
// ./src/core/redux/action/dashboardAction.ts